import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { Input, Input3 } from "../../../common/components/control/InputField";
import { transferSchema } from "../../yupSchema/transferSchema";

export const TransferForm = ({ formikRef, saveValues }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={{
        username: "",
        amount: "",
      }}
      innerRef={formikRef}
      validationSchema={transferSchema(intl)}
      enableReinitialize={true}
      onSubmit={(values, formikHelpers) => {
        const queryParams = {
          amount: values.amount,
          selusername: values.username,
        };

        saveValues(queryParams);
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <label
            className="mb-2 text-input-label text-font3"
            style={{ color: "white" }}
          >
            {intl.formatMessage({ id: "username" })}
          </label>
          <div className="mb-2">
            <Field
              className="text-font2"
              name="username"
              component={Input3}
              placeholder={intl.formatMessage({ id: "username" })}
              autoComplete="off"
              type="text"
            />
          </div>
          <label
            className="mb-2 text-input-label text-font3"
            style={{ color: "white" }}
          >
            {intl.formatMessage({ id: "amount" })}
          </label>
          <div className="mb-2">
            <Field
              className="text-font2"
              name="amount"
              component={Input}
              placeholder={intl.formatMessage({ id: "amount" })}
              autoComplete="off"
              type="number"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
